import { useQuery, gql, type QueryHookOptions } from "@apollo/client";

const TEAM_MEMBER_QUERY = gql`
  query TeamMember($slug: String!) {
    teamMember(slug: $slug) {
      id
      avatarLarge
      name
      position
      phone
      description
      listingAgent {
        id
        key
      }
    }
  }
`;

interface TeamMemberVariables {
  slug: string;
}

interface ListingAgent {
  id: string;
  key: string;
}

interface TeamMemberData {
  teamMember: {
    id: string;
    avatarLarge: string | null;
    name: string;
    position: string | null;
    phone: string | null;
    description: string | null;
    listingAgent: ListingAgent | null;
  };
}

const useTeamMemberQuery = (options?: QueryHookOptions<TeamMemberData, TeamMemberVariables>) => {
  return useQuery<TeamMemberData, TeamMemberVariables>(TEAM_MEMBER_QUERY, options);
};

export { useTeamMemberQuery };
export type { TeamMemberData, TeamMemberVariables };
